import React, { useState, useEffect } from "react";
import { MainAdminNewsesTop } from "../../components/"
import { axiosReq } from "../../commons/axiosReq";
import Cookies from 'universal-cookie';
import MainAdminPublishedTable from "../../components/MainAdmin/Table/MainAdminPublishedTable";

const MainAdminPublishedNewses = () => {

    const titleRow = ["عنوان خبر", "دسته بندی", "تاریخ انتشار", "نویسنده","بازدید"];
    const example = ["رشد ارز چه آثاری بر روی قیمت خودرو دارد؟", "طلا و ارز", "1403/04/16", "علیرضا بابایی"];

    const [showEditModal, setShowEditModal] = React.useState(false);
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);
    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [btnSearch, setBtnSearch] = useState(false);
    const [reCheck, setRecheck] = useState(false);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    const [cats, setCats] = useState();
    const [cat, setCat] = useState(0);
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [prominent, setProminent] = useState(false);
    const [last, setLast] = useState(false);
    const [most, setMost] = useState(false);
    const [main, setMain] = useState(false);
    const [admins, setAdmins] = useState();
    const [admin, setAdmin] = useState();

    const GetData = async () => {
        const writersData = await axiosReq(`Article/GetPublishedArticleList?page=${page}&&pageSize=${row}&&search=${encodeURIComponent(debouncedSearch)}&&category=${cat}&&startDate=${start}&&endDate=${end}&&userId=${admin || 0}`, "get");
        setData(writersData?.data)
        setCount(writersData?.count)

    }
    const GetData2 = async () => {


        const options = await axiosReq("Article/GetEditorOptions", "get");
        setCats(options?.categories || [])
                const cookies = new Cookies();
        
        if (cookies.get('role') == "Admin") {

        setAdmins(options?.authors || [])
    }
    }
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearch(search), 350);
        return () => clearTimeout(timer);
    }, [search]);

    useEffect(() => {
        setPage(1);
    }, [debouncedSearch, cat, start, end, admin]);

    useEffect(() => {

        GetData();
    }, [reCheck, btnSearch, page, row, cat, start, end, debouncedSearch,
        admin, prominent, last, most, main]);

    useEffect(() => {

        GetData2();
    }, []);



    return (
        <div>
            <div><MainAdminNewsesTop mode={true} cats={cats} setCat={setCat} setStart={setStart} start={start} end={end} 
            setEnd={setEnd} setAdmin={setAdmin} setSearch={setSearch} setBtnSearch={setBtnSearch} btnSearch={btnSearch}
                setProminent={setProminent} setLast={setLast} setMost={setMost} setMain={setMain} admins={admins}
            >اخبار منتشر شده</MainAdminNewsesTop></div>


            <div className="pt-[20px] px-[20px] pb-[280px]">
                <MainAdminPublishedTable detail={true} edit={true} block={false} deleted={true}
                    setShowEditModal={setShowEditModal} setShowBlockModal={null} setShowDeleteModal={setShowDeleteModal}
                    titleRow={titleRow} example={example} data={data} setRecheck={setRecheck} reCheck={reCheck}
                    count={count} page={page} setPage={setPage} row={row} setRow={setRow} />
            </div>

        </div>
    )
}

export default MainAdminPublishedNewses;
